export enum TextType {
  Paragraph = 'paragraph',
  Heading1 = 'heading1',
  Heading2 = 'heading2',
  Subheading = 'subHeading',
  Label = 'label',
}
